import React, { useCallback, useEffect, useMemo, useState } from 'react'

import { useAppDispatch } from '@/hooks/redux'
import { FORM_FIELDS } from '@/pages/getRecipe/fullLayering/framework/utils/formTypes'
import { useAppSelector } from '@/store'
import { removeFrameWorkIndex } from '@/store/appSlice'
import { resetFrameworkRecipeState } from '@/store/fullLayering'
import { Workflows, showPrepColorPicker } from '@/utils/constants'

import MaterialAdviceTooltip from './components/MatrialAdviceTooltip'

const KonvaFrameWork = () => {
  const dispatch = useAppDispatch()
  const frameWorkRecipeOutput = useAppSelector(
    (state) => state.fullLayering.frameWorkRecipeOutput,
  )

  const targetColor = useAppSelector((state) => state.fullLayering.targetColor)

  const selectedIndication = useAppSelector(
    (state) => state.fullLayering.frameWorkform[FORM_FIELDS.INDICATION],
  )

  const canvasImage = useAppSelector((state) => state.app.canvasImage)

  const [tooltipOpen, setTooltipOpen] = useState(true)
  const [lockedPosition, setLockedPosition] = useState<{
    x: number
    y: number
  } | null>(null)
  const [prevOutputJson, setPrevOutputJson] = useState<string>('')

  const output = frameWorkRecipeOutput?.[canvasImage?.id]
  const colorData = targetColor

  const shouldUseIncisal = useMemo(
    () => showPrepColorPicker.includes(selectedIndication),
    [selectedIndication],
  )

  const regionKey =
    shouldUseIncisal && colorData?.INCISAL?.imagePosition ? 'INCISAL' : 'MIDDLE'

  const regionData = colorData?.[regionKey]?.imagePosition

  useEffect(() => {
    const currentOutputJson = JSON.stringify(output)

    if (output && currentOutputJson !== prevOutputJson && regionData) {
      setLockedPosition(regionData)
      setPrevOutputJson(currentOutputJson)
    }
  }, [output, regionData, prevOutputJson])

  const handleToggleTooltip = useCallback(() => {
    setTooltipOpen((prev) => !prev)
  }, [])

  const handleCloseTooltip = useCallback(() => {
    setTooltipOpen(false)
  }, [])

  const handleDeleteFramework = useCallback(() => {
    if (!canvasImage?.id) return

    dispatch(resetFrameworkRecipeState({ imageId: canvasImage.id }))
    dispatch(
      removeFrameWorkIndex({
        workflow: Workflows.FULL_LAYERING,
        imageId: canvasImage.id,
      }),
    )
  }, [dispatch, canvasImage?.id])

  if (!output || !lockedPosition) return null

  return (
    <MaterialAdviceTooltip
      key={regionKey}
      keyName={regionKey}
      data={lockedPosition}
      output={output}
      open={tooltipOpen}
      toggle={handleToggleTooltip}
      close={handleCloseTooltip}
      workflow={Workflows?.FULL_LAYERING}
      onDelete={handleDeleteFramework}
    />
  )
}

export default KonvaFrameWork
